import authApi from '@/api/authApi';
import roleUtil from '@/utils/roleUtil';
import * as roles from '@/constants/roles';

export default {
    namespaced: true,

    state: {
        authenticated: false,
        user: null
    },

    getters: {
        isOperator: state => {
            return !!state.user && roleUtil.check(state.user, roles.OPERATOR);
        },
        isRestaurateur: state => {
            return (
                !!state.user && roleUtil.check(state.user, roles.RESTAURATEUR)
            );
        }
    },

    mutations: {
        SET_AUTHENTICATED(state, value) {
            state.authenticated = value;
        },
        SET_USER(state, value) {
            state.user = value;
        }
    },

    actions: {
        async login({ commit }, credentials) {
            const response = await authApi.spaLogin(credentials);
            const user = response.data.user;
            commit('SET_AUTHENTICATED', true);
            commit('SET_USER', user);
            return user;
        },
        async logout({ commit }) {
            await authApi.spaLogout();
            commit('SET_AUTHENTICATED', false);
            commit('SET_USER', null);
        }
    }
};
